module.exports = __webpack_public_path__ + "static/media/trust.acdcb7db.png";